import { UPDropdownItem } from 'components/dropdown';
import UPDropdownWithInput from 'components/dropdown-with-input';
import HOUR_OPTIONS from 'modules/contracts/HourDropdownOptions';
import { Controller, useFieldArray, UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import {
  CONTRACTS__ADD_EXTRA_BREAK,
  CONTRACTS__BREAK,
  CONTRACTS__END_WORK,
  CONTRACTS__START_WORK,
  CONTRACTS__TO_BE_CONFIRMED,
  GENERAL__DELETE,
} from 'translations/constants';
import { ReactComponent as ConfirmedProcessingIcon } from '../../../assets/icons/ConfirmedProcessingIcon.svg';
import {
  AddBreakContainer,
  BreakDivider,
  BreakHeaderRow,
  BreakTitle,
  ColumnTitleRow,
  LinkButton,
  SubSectionTitle,
  TimeColumnContainer,
  TimeFieldsRow,
  TimeFieldWrapperSmall,
} from '../styles';
import { DetailPanelFormValues } from '../types';

interface ToBeConfirmedColumnProps {
  form: UseFormReturn<DetailPanelFormValues>;
}

const filterByHour = (options: UPDropdownItem[], state: { inputValue: string }) => {
  return options.filter(option => option.label.toLowerCase().startsWith(state.inputValue.toLowerCase()));
};

const ToBeConfirmedColumn = (props: ToBeConfirmedColumnProps) => {
  const { form } = props;
  const { t } = useTranslation();
  const { fields, append, remove } = useFieldArray({ control: form.control, name: 'breaks' });

  return (
    <TimeColumnContainer>
      <ColumnTitleRow>
        <ConfirmedProcessingIcon />
        <SubSectionTitle>{t(CONTRACTS__TO_BE_CONFIRMED)}</SubSectionTitle>
      </ColumnTitleRow>
      <TimeFieldsRow>
        <TimeFieldWrapperSmall>
          <Controller
            name="startWork"
            control={form.control}
            render={({ field }) => (
              <UPDropdownWithInput
                value={field.value}
                handleChange={field.onChange}
                placeholder=""
                items={HOUR_OPTIONS}
                label={t(CONTRACTS__START_WORK)}
                type="startWork"
                filterOptions={filterByHour}
                id="detail-panel-confirm-start"
              />
            )}
          />
        </TimeFieldWrapperSmall>
        <TimeFieldWrapperSmall>
          <Controller
            name="endWork"
            control={form.control}
            render={({ field }) => (
              <UPDropdownWithInput
                value={field.value}
                handleChange={field.onChange}
                placeholder=""
                items={HOUR_OPTIONS}
                label={t(CONTRACTS__END_WORK)}
                type="endWork"
                filterOptions={filterByHour}
                id="detail-panel-confirm-end"
              />
            )}
          />
        </TimeFieldWrapperSmall>
      </TimeFieldsRow>
      <BreakDivider />
      {fields.length > 0 && (
        <div>
          <BreakHeaderRow>
            <BreakTitle>{`${t(CONTRACTS__BREAK)}`}</BreakTitle>
            <LinkButton type="button" onClick={() => remove(0)}>
              {t(GENERAL__DELETE)}
            </LinkButton>
          </BreakHeaderRow>
          <TimeFieldsRow>
            <TimeFieldWrapperSmall>
              <Controller
                name="breaks.0.startBreak"
                control={form.control}
                render={({ field }) => (
                  <UPDropdownWithInput
                    value={field.value}
                    handleChange={field.onChange}
                    placeholder=""
                    items={HOUR_OPTIONS}
                    label={t(CONTRACTS__START_WORK)}
                    type="startBreak"
                    filterOptions={filterByHour}
                    id="detail-panel-confirm-break-0-start"
                  />
                )}
              />
            </TimeFieldWrapperSmall>
            <TimeFieldWrapperSmall>
              <Controller
                name="breaks.0.endBreak"
                control={form.control}
                render={({ field }) => (
                  <UPDropdownWithInput
                    value={field.value}
                    handleChange={field.onChange}
                    placeholder=""
                    items={HOUR_OPTIONS}
                    label={t(CONTRACTS__END_WORK)}
                    type="endBreak"
                    filterOptions={filterByHour}
                    id="detail-panel-confirm-break-0-end"
                  />
                )}
              />
            </TimeFieldWrapperSmall>
          </TimeFieldsRow>
        </div>
      )}
      {fields.length === 0 && (
        <AddBreakContainer>
          <LinkButton type="button" onClick={() => append({ startBreak: '', endBreak: '' })}>
            {t(CONTRACTS__ADD_EXTRA_BREAK)}
          </LinkButton>
        </AddBreakContainer>
      )}
    </TimeColumnContainer>
  );
};

export default ToBeConfirmedColumn;
